import React from "react";

import { Minus, Plus } from "react-feather";

const TodoHeader = props => {
  const { open, setOpen } = props;

  const icon = open ? <Minus /> : <Plus />;

  return (
    <div className="header todo__header">
      <span>Lista de tarefas</span>

      <button onClick={() => setOpen(!open)} className="action-btn" title="Expandir e colapsar">
        {icon}
      </button>
    </div>
  );
}

export default TodoHeader;